import * as R from "ramda";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInstallableComponents } from "../api/marketplace";
import { listPackages, listInstalledPackages } from "../api/package";
import { useApps } from "../hook";
import { ActionType, AppDispatch, RootState } from "../reducer";
import { App } from "../types/app";
import { Component } from "../types/component";
import { Registration } from "../types/marketplace";
import { useAddComponents } from "./component";
import { AddRegistrationsAction } from "../reducer/marketplace";
import { useAddPackages, useSetInstalledPackages } from "./package";
import { useAppIdMap } from "./app";

export const useAddRegistrations = () => {
  const dispatch = useDispatch<AppDispatch>();
  return (registrations: Registration[]) => {
    const action: AddRegistrationsAction = {
      type: ActionType.ADD_REGISTRATIONS,
      registrations,
    };
    dispatch(action as any);
  };
};

export const useFetchComponentsFromMarketplaceListener = () => {
  const [appsState, setApps] = useApps();
  const addComponents = useAddComponents();
  const addRegistrations = useAddRegistrations();
  useEffect(() => {
    getInstallableComponents({}).then((res) => {
      const regIndex = R.indexOf("registration", res["header"]);
      const appIndex = R.indexOf("app", res["header"]);
      const compIndex = R.indexOf("component", res["header"]);
      const regs: Registration[] = res["rows"].map(R.nth(regIndex));
      const apps: App[] = res["rows"]
        .map(R.nth(appIndex))
        .map(({ "app-id": appId, ...app }) => ({ ...app, id: appId }));
      const comps: Component[] = res["rows"].map(R.nth(compIndex));
      const newApps = R.uniqBy(R.prop("id"), [...appsState, ...apps]);
      setApps(newApps);
      addComponents(comps);
      addRegistrations(regs);
    });
  }, []);
};

export const useRegistrations = () => {
  const regs = useSelector((state: RootState) => state.connectors.registrations);
  return regs;
};

export const useFetchPackagesListener = () => {
  const addPackages = useAddPackages();
  useEffect(() => {
    listPackages({ limit: 100, skip: 0 }).then((res) => {
      if (res && Array.isArray(res.packages)) {
        addPackages(res.packages);
      }
    });
  }, []);
};

export const useFetchInstalledListener = (appId: string | undefined) => {
  const setInstalledPackages = useSetInstalledPackages();
  useEffect(() => {
    if (!appId) return;
    listInstalledPackages({ "app-id": appId }).then((res) => {
      if (res && Array.isArray(res.installs)) {
        setInstalledPackages(res.installs);
      }
    });
  }, [appId]);
};
